export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8073.3a8b154e.jpg";